import React from 'react'
import { Stack, Typography, useTheme } from '@mui/material'
import { EmailMessageLogDto, EmailTemplateDto } from '../../services/api/sharedTypes/Email'
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

interface EventSurveysProps {
    emailMessageLog: EmailMessageLogDto[]
    emailTemplates: EmailTemplateDto[]
}

const EventSurveys: React.FC<EventSurveysProps> = ({ emailMessageLog, emailTemplates }: EventSurveysProps) => {
    const theme = useTheme()

    return (
        <div
            style={{
                backgroundColor: theme.palette.background.default,
                padding: theme.spacing(3),
            }}
        >
            <Stack spacing={3}>
                <Typography variant='h6' color='primary'>Korespondence klient</Typography>

                <Stack direction='row' justifyContent='space-between' spacing={5}>
                    <Typography variant='caption'>Předmět</Typography>
                    <Typography variant='caption'>Posláno</Typography>
                </Stack>
                {emailMessageLog.map((emailMessage, index) => {
                    const emailTemplate = emailTemplates.find((emailTemplate) => emailTemplate.type === emailMessage.type)
                    return (
                        <Stack direction='row' justifyContent='space-between' spacing={5} key={index}>
                            <Typography variant='body1'>{emailTemplate?.subject}</Typography>
                            <Typography variant='body1'>
                                {emailMessage.sentAt ? <CheckIcon color='success' /> : <CloseIcon color='error' />}
                            </Typography>
                        </Stack>
                    )
                })}
            </Stack>
        </div>
    )
}

export default EventSurveys
